module.exports = __webpack_public_path__ + "img/ppr-modal-border-accent.1da07d7b.svg";